import { AppPlugins } from 'app/constants'
import Plugin from 'core/plugins/plugin'
import ClusterBlueprintPage from 'app/plugins/openstack/components/infrastructure/blueprint/ClusterBlueprintPage'
import Dashboard from 'openstack/components/dashboard/Dashboard'
import FlavorsListPage from 'openstack/components/flavors/FlavorsListPage'
import ImagesListPage from 'openstack/components/images/ImagesListPage'
import ImageDetailsPage from 'openstack/components/images/details/ImageDetailsPage'
import HostAggregatesListPage from 'openstack/components/infrastructure/host-aggregates/HostAggregatesListPage'
import AddVmwareGatewayPage from 'openstack/components/infrastructure/hosts/AddVmwareGatewayPage'
import HostsListPage from 'openstack/components/infrastructure/hosts/HostsListPage'
import HostDetailsPage from 'openstack/components/infrastructure/hosts/host-details/HostDetailsPage'
import NetworksListPage from 'openstack/components/networks/NetworksListPage'
import FloatingIpsListPage from 'openstack/components/networks/floating-ips/FloatingIpsListPage'
import NetworkDetailsPage from 'openstack/components/networks/network-details/NetworkDetailsPage'
import RouterDetailsPage from 'openstack/components/networks/routers/RouterDetailsPage'
import RoutersListPage from 'openstack/components/networks/routers/RoutersListPage'
import SecurityGroupsListPage from 'openstack/components/networks/security-groups/SecurityGroupsListPage'
import VirtualNetworkDetailsPage from 'openstack/components/networks/virtual-networks/VirtualNetworkDetailsPage'
import VirtualNetworksListPage from 'openstack/components/networks/virtual-networks/VirtualNetworksListPage'
import VmwareNetworkDetailsPage from 'openstack/components/networks/vmware-networks/VmwareNetworkDetailsPage'
import VmwareNetworksListPage from 'openstack/components/networks/vmware-networks/VmwareNetworksListPage'
import StackDetailsPage from 'openstack/components/orchestration/StackDetailsPage'
import StacksListPage from 'openstack/components/orchestration/StacksListPage'
import SshKeysListPage from 'openstack/components/security/keys/SshKeysListPage'
import ApplicationCredentialsListPage from 'openstack/components/security/application-credentials/ApplicationCredentialsListPage'
import ApplicationCredentialDetailsPage from 'openstack/components/security/application-credentials/ApplicationCredentialDetailsPage'
import StorageDashboardPage from 'openstack/components/storage/dashboard/StorageDashboardPage'
import VolumeSnapshotsListPage from 'openstack/components/storage/snapshots/VolumeSnapshotsListPage'
import VolumeSnapshotDetailsPage from 'openstack/components/storage/snapshots/details/VolumeSnapshotDetailsPage'
import VolumeTypesListPage from 'openstack/components/storage/volume-types/VolumeTypesListPage'
import VolumeTypeDetailsPage from 'openstack/components/storage/volume-types/details/VolumeTypeDetailsPage'
import VolumesListPage from 'openstack/components/storage/volumes/VolumesListPage'
import VolumeDetailsPage from 'openstack/components/storage/volumes/volume-details/VolumeDetailsPage'
import VirtualMachinesListPage from 'openstack/components/vms/VirtualMachinesListPage'
import ServerGroupsListPage from 'openstack/components/vms/server-groups/ServerGroupsListPage'
import VmDetailsPage from 'openstack/components/vms/vm-details/VmDetailsPage'
import { openstackLogo } from '../openstack/logo'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
import LoadBalancerDetailsPage from './components/networks/load-balancers/LoadBalancerDetailsPage'
import { kubernetesNav, kubernetesRoutesMapping } from './kubernetesNav'
import NotificationsPage from 'core/components/notifications/NotificationsPage'
import DnsTabsPage from 'app/plugins/openstack/components/networks/dns/DnsTabsPage'
import { isKaapiEnabled, isOpenCloud } from 'core/utils/helpers'
import ClusterHostGroupsListPage from './components/infrastructure/clusters/ClusterHostGroupsListPage'
import ClusterHostGroupDetailsPage from './components/infrastructure/clusters/details/ClusterHostGroupDetailsPage'
import ServiceHealthDetailsPage from 'app/plugins/infrastructure/components/common/service-health/ServiceHealthDetailsPage'
import RepositoryListPage from './components/orchestration/repositories/RepositoryListPage'
import AppsDetailsPage from './components/orchestration/app-catalog/AppsDetailsPage'
import GpuPage from './components/infrastructure/gpu/GpuPage'

const openstackPlugin = new Plugin(
  AppPlugins.OpenStack,
  'Virtualized Clusters',
  '/ui/pcd',
  openstackLogo,
  'Virtualized clusters for traditional workloads',
)

export const openstackRoutes = [
  {
    name: 'Dashboard',
    link: { path: 'dashboard', exact: true, default: isOpenCloud() ? false : true },
    component: Dashboard,
  },
  {
    name: 'Virtual Machines',
    link: {
      path: '/compute/vms/:vmstab/(deploy)?',
      navPath: '/compute/vms/:vmstab',
      exact: true,
    },
    component: VirtualMachinesListPage,
  },
  {
    name: 'Virtual Machine Details',
    link: { path: '/compute/vms/list/:id/:tab?', exact: true },
    component: VmDetailsPage,
  },
  {
    name: 'Server Groups',
    link: { path: '/compute/server-groups/(create)?', exact: true },
    component: ServerGroupsListPage,
  },
  {
    name: 'Notifications',
    link: { path: '/notifications/:notificationType/:id?', exact: true },
    component: NotificationsPage,
  },
  {
    name: 'Images & VM Snapshots',
    link: { path: '/images/:tab?/(add||import)?', exact: true },
    component: ImagesListPage,
  },
  {
    name: 'Image Details',
    link: { path: '/images/:id/:detailsTab?', exact: true },
    component: ImageDetailsPage,
  },
  {
    name: 'Flavors',
    link: { path: '/flavors/(create)?', exact: true },
    component: FlavorsListPage,
  },
  {
    name: 'Storage Dashboard',
    link: { path: '/storage/dashboard', exact: true },
    component: StorageDashboardPage,
  },
  {
    name: 'Volumes',
    link: { path: '/storage/volumes/(create)?', exact: true },
    component: VolumesListPage,
  },
  {
    name: 'Volume Details',
    link: { path: '/storage/volumes/:id/:tab?', exact: true },
    component: VolumeDetailsPage,
  },
  {
    name: 'Volume Types',
    link: { path: '/storage/volume-types/(create)?', exact: true },
    component: VolumeTypesListPage,
  },
  {
    name: 'Volume Type Details',
    link: { path: '/storage/volume-types/:id/:tab?', exact: true },
    component: VolumeTypeDetailsPage,
  },
  {
    name: 'Volume Snapshots',
    link: { path: '/storage/snapshots', exact: true },
    component: VolumeSnapshotsListPage,
  },
  {
    name: 'Volume Snapshot Details',
    link: { path: '/storage/snapshots/:id/:tab?', exact: true },
    component: VolumeSnapshotDetailsPage,
  },
  {
    name: 'Networks',
    link: { path: '/networking/networks/(create)?', exact: true },
    component: NetworksListPage,
  },
  {
    name: 'Create Physical Network',
    link: { path: '/networking/networks/create-physical-network', exact: true },
    component: NetworksListPage,
  },
  {
    name: 'Create Virtual Network',
    link: { path: '/networking/networks/create-virtual-network', exact: true },
    component: NetworksListPage,
  },
  {
    name: 'Network Details',
    link: { path: '/networking/networks/:id/:tab?/(create)?', exact: true },
    component: NetworkDetailsPage,
  },
  {
    name: 'Virtual Networks',
    link: { path: '/networking/virtual-networks/(create)?', exact: true },
    component: VirtualNetworksListPage,
  },
  {
    name: 'Virtual Network Details',
    link: { path: '/networking/virtual-networks/:id/:tab?/(create)?', exact: true },
    component: VirtualNetworkDetailsPage,
  },
  {
    name: 'Networks',
    link: { path: '/networking/vmw-networks/(create)?', exact: true },
    component: VmwareNetworksListPage,
  },
  {
    name: 'Network Details',
    link: { path: '/networking/vmw-networks/:id/:tab?/(create)?', exact: true },
    component: VmwareNetworkDetailsPage,
  },
  {
    name: 'Routers',
    link: { path: '/networking/routers/(create)?', exact: true },
    component: RoutersListPage,
  },
  {
    name: 'Router Details',
    link: { path: '/networking/routers/:id/:tab?/(create)?', exact: true },
    component: RouterDetailsPage,
  },
  {
    name: 'Public IPs',
    link: { path: '/networking/public-ips/(create)?', exact: true },
    component: FloatingIpsListPage,
  },
  {
    name: 'Security Groups',
    link: { path: '/networking/security-groups/(create)?', exact: true },
    component: SecurityGroupsListPage,
  },
  {
    name: 'DNS',
    link: { path: '/networking/dns/:tab/(create)?', exact: true },
    component: DnsTabsPage,
  },
  {
    name: 'Edit DNS',
    link: { path: '/networking/dns/:tab/edit/:id', exact: true },
    component: DnsTabsPage,
  },
  {
    name: 'Load Balancers Details',
    link: { path: '/networking/load-balancers/:tab?/(create)?', exact: true },
    component: LoadBalancerDetailsPage,
  },
  {
    name: 'Cluster Blueprint',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/blueprint', exact: true },
    component: ClusterBlueprintPage,
  },
  {
    name: 'Cluster Hosts',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/hosts/:hoststab/(add)?', exact: true },
    component: HostsListPage,
  },
  {
    name: 'Add VMware Gateway',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/hosts/list/add-gateway', exact: true },
    component: AddVmwareGatewayPage,
  },
  {
    name: 'Cluster Host Details',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/hosts/list/:id/:tab?', exact: true },
    component: HostDetailsPage,
  },
  {
    name: 'Host Aggregates',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/host-aggregates/(create)?', exact: true },
    component: HostAggregatesListPage,
  },
  {
    name: 'GPU Hosts',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/gpu/:tab?', exact: true },
    component: GpuPage,
  },
  {
    name: 'Ssh Keys',
    link: { path: '/access/ssh-key/(import)?', exact: true },
    component: SshKeysListPage,
  },
  {
    name: 'Application Credentials',
    requiredRoles: 'admin',
    link: { path: '/access/application-credentials/(create)?', exact: true },
    component: ApplicationCredentialsListPage,
  },
  {
    name: 'Application Credential Details',
    requiredRoles: 'admin',
    link: { path: '/access/application-credentials/:id', exact: true },
    component: ApplicationCredentialDetailsPage,
  },
  {
    name: 'Stacks',
    link: { path: '/orchestration/stacks/(create)?', exact: true },
    component: StacksListPage,
  },
  {
    name: 'Stack Details',
    link: { path: '/orchestration/stacks/:name/:id/:tab?', exact: true },
    component: StackDetailsPage,
  },

  {
    name: 'Apps',
    link: { path: '/orchestration/apps/:tab?/(create)?', exact: true },
    component: AppsDetailsPage,
  },
  {
    name: 'Apps',
    link: { path: '/orchestration/apps/:tab?/(template)?', exact: true },
    component: AppsDetailsPage,
  },
  {
    name: 'Git Repository',
    link: { path: '/orchestration/repository/(create)?', exact: true },
    component: RepositoryListPage,
  },
  {
    name: 'Clusters',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/clusters/(create)?', exact: true },
    component: ClusterHostGroupsListPage,
  },
  {
    name: 'Cluster Details',
    requiredRoles: 'admin',
    link: { path: '/infrastructure/clusters/:id', exact: true },
    component: ClusterHostGroupDetailsPage,
  },
  {
    name: 'Service Health',
    link: { path: '/health/:tab?', exact: true },
    component: ServiceHealthDetailsPage,
  },

  ...(isKaapiEnabled() ? kubernetesRoutesMapping : []),
]

export const openstackNavItems = ({ includeVMwareGateway = false }) => [
  {
    name: 'Home',
    link: { path: '/dashboard', definition: '/dashboard' },
    icon: 'house',
  },
  {
    name: 'Infrastructure',
    icon: 'buildings',
    requiredRoles: 'admin',
    link: {
      path: '/infrastructure/hosts/list',
      definition: '/infrastructure/hosts/:tab/:id?',
    },
    nestedLinks: [
      {
        name: 'Cluster Blueprint',
        link: {
          path: '/infrastructure/blueprint',
          definition: '/infrastructure/blueprint',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'Clusters',
        link: {
          path: '/infrastructure/clusters',
          definition: '/infrastructure/clusters',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'Cluster Hosts',
        link: {
          path: '/infrastructure/hosts/list',
          definition: '/infrastructure/hosts/:tab/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      // VMware Gateway
      ...(includeVMwareGateway
        ? [
            {
              name: 'VMware Gateway',
              link: {
                path: '/infrastructure/hosts/list',
                definition: '/infrastructure/hosts/:tab/:id?',
              },
              requiredFeatures: (features) => {
                return features?.experimental?.pmov2_du_type === 'vmware'
              },
            },
          ]
        : []),
      {
        name: 'GPU Hosts',
        link: {
          path: '/infrastructure/gpu/hosts',
          definition: '/infrastructure/gpu/:tab?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'Host Aggregates',
        link: {
          path: '/infrastructure/host-aggregates',
          definition: '/infrastructure/host-aggregates/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
    ],
  },
  {
    name: 'Virtual Machines',
    icon: 'desktop',
    link: { path: '/compute/vms/list', definition: '/compute/vms/:tab/:id?' },
    nestedLinks: [
      {
        name: 'Virtual Machines',
        link: {
          path: '/compute/vms/list',
          definition: '/compute/vms/:tab/:id?',
        },
      },
      {
        name: 'Server Groups',
        link: {
          path: '/compute/server-groups',
          definition: '/compute/server-groups',
        },
      },
      {
        name: 'Images & VM Snapshots',
        link: {
          path: '/images/images',
          definition: '/images/:tab?',
        },
      },
      {
        name: 'Flavors',
        link: {
          path: '/flavors',
          definition: '/flavors',
        },
      },
    ],
  },
  {
    name: 'Storage',
    icon: 'coins',
    link: { path: '/storage/dashboard', definition: '/storage/:tab' },
    nestedLinks: [
      {
        name: 'Dashboard',
        link: {
          path: '/storage/dashboard',
          definition: '/storage/dashboard',
        },
      },
      {
        name: 'Volumes',
        link: {
          path: '/storage/volumes',
          definition: '/storage/volumes',
        },
      },
      {
        name: 'Volume Types',
        link: {
          path: '/storage/volume-types',
          definition: '/storage/volume-types',
        },
      },
      {
        name: 'Volume Snapshots',
        link: {
          path: '/storage/snapshots',
          definition: '/storage/snapshots',
        },
      },
    ],
  },
  {
    name: 'Networks and Security',
    icon: 'network-wired',
    link: { path: '/networking/networks', definition: '/networking/:tab' },
    nestedLinks: [
      {
        name: 'Networks',
        link: {
          path: '/networking/networks',
          definition: '/networking/networks/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },

      {
        name: 'Networks',
        link: {
          path: '/networking/vmw-networks',
          definition: '/networking/vmw-networks/:id?',
        },
        requiredFeatures: (features) => features?.experimental?.pmov2_du_type === 'vmware',
      },
      {
        name: 'Routers',
        link: {
          path: '/networking/routers',
          definition: '/networking/routers/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'Public IPs',
        link: {
          path: '/networking/public-ips',
          definition: '/networking/public-ips/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'Security Groups',
        link: {
          path: '/networking/security-groups',
          definition: '/networking/security-groups/:id?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },

      {
        name: 'Load Balancers',
        link: {
          path: '/networking/load-balancers/loadBalancers',
          definition: '/networking/load-balancers/:tab?',
        },
        requiredFeatures: (features) => {
          return !(features?.experimental?.pmov2_du_type === 'vmware')
        },
      },
      {
        name: 'DNS',
        link: {
          path: '/networking/dns/pools?view=list',
          definition: '/networking/dns/:tab',
        },
      },
    ],
  },
  {
    name: 'Access & Security',
    icon: 'key',
    link: { path: '/access/ssh-key', definition: '/access/:tab' },
    nestedLinks: [
      {
        name: 'SSH Key',
        link: {
          path: '/access/ssh-key',
          definition: '/access/ssh-key/:id?',
        },
      },
      {
        name: 'Application Credentials',
        requiredRoles: 'admin',
        link: {
          path: '/access/application-credentials',
          definition: '/access/application-credentials/:id?',
        },
        requiredFeatures: (features) => {
          return isAdmin()
        },
      },
    ],
  },
  {
    name: 'Orchestration',
    icon: 'cubes',
    link: { path: '/orchestration/repository', definition: '/orchestration/:tab' },
    nestedLinks: [
      {
        name: 'Git Repository',
        link: {
          path: '/orchestration/repository',
          definition: '/orchestration/repository',
        },
      },
      {
        name: 'Apps',
        isBetaVersion: true,
        betaVersionTooltip: 'This feature is in Beta and subject to change. We welcome feedback.',
        link: {
          path: '/orchestration/apps/myapps',
          definition: '/orchestration/apps/:tab?',
        },
      },
    ],
  },
  ...(isKaapiEnabled() ? [kubernetesNav] : []),
]

openstackPlugin.registerRoutes(openstackRoutes)
openstackPlugin.registerNavItems(openstackNavItems({ includeVMwareGateway: false }))

export default openstackPlugin
